module.exports = __webpack_public_path__ + "img/cocteleria_1.4d202853.jpeg";